import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AlumnisListComponent } from '../alumnis/alumnis-list/alumnis-list.component';

@Component({
  selector: 'app-page-home',
  templateUrl: './page-home.component.html',
  standalone: true,
  imports: [AlumnisListComponent],
  styleUrls: ['./page-home.component.scss']
})
export class PageHomeComponent implements OnInit {
  public event_name = environment.event_name;
  public event_year = environment.event_year;

  constructor() { }

  ngOnInit(): void {
  }

}
